import ProfileDropDown from "./ProfileDropDown";
import { MenuAlt4Icon } from "@heroicons/react/solid";
import "./header.css";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  COMPANY_EMPLOYEE_ID,
  COMPANY_ID,
  COMPANYNAME,
  IS_CHAT,
  IS_HRMS,
  IS_LIVE_TRACKING,
  NAME,
  REDIRECT_URL,
  ROLE,
  SERVICE_KEY,
  TOKEN_NAME,
  USERNAME,
} from "../config";
import { Button } from "./ui";
import { getCookieDomain } from "../utility";
import useAppBrandInfo from "../hooks/useAppBrandInfo";

const cookies = new Cookies();

function Header({ onMenuClick, onProfileClick, hasAccess = true }) {
  const brandInfo = useAppBrandInfo();
  const handleMenuToggle = () => {
    onMenuClick();
  };

  const handleLogout = () => {
    const cookieNames = [
      TOKEN_NAME,
      COMPANYNAME,
      NAME,
      COMPANY_ID,
      ROLE,
      USERNAME,
      COMPANY_EMPLOYEE_ID,
      IS_LIVE_TRACKING,
      IS_CHAT,
      IS_HRMS,
    ];

    const baseOptions = {
      path: "/",
      domain: getCookieDomain(),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
    };

    for (let i = 0; i < cookieNames.length; i++) {
      cookies.remove(cookieNames[i], baseOptions);
    }

    localStorage.clear();
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
  };

  return (
    <>
      <div className="text-black bg-white h-16 px-4 fixed top-0 mb-4 z-[1001] w-full shadow-lg flex items-center justify-between">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src={brandInfo.app_logo_url || "/idom-logo.webp"}
            alt={`${brandInfo.app_name || "iDoM"} Logo`}
            className="h-10 w-auto md:h-12 object-contain hidden sm:block"
          />
          <img
            src={brandInfo.fav_icon_url || "/favicon.jpg"}
            alt={`${brandInfo.app_name || "iDoM"} Logo`}
            className="h-9 w-9 object-contain rounded sm:hidden"
          />
        </Link>

        <div className="flex items-center justify-between h-full">
          <div className="flex items-center gap-2">
            {/* Mobile user profile button */}
            <div className="relative lg:hidden">
              <ProfileDropDown handleLogout={handleLogout} />
            </div>

            {hasAccess && (
              <div className="block lg:hidden">
                <Button
                  size={"icon"}
                  variant={"ghost"}
                  onClick={handleMenuToggle}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <MenuAlt4Icon className="w-6 h-6" />
                </Button>
              </div>
            )}
          </div>
          <div className="relative hidden lg:block">
            <ProfileDropDown handleLogout={handleLogout} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
